<template>
  <div>
    <v-container v-if='isLoading'>
      <wc-loading line message='Getting inquiry details'></wc-loading>
    </v-container>
    <wc-page-title :title='title' :subtitle='subtitle' v-if='!isLoading'>
      <template v-slot:rightSide>
        <wc-estimate-generated v-if='inquiry && inquiry.estimate_generated'></wc-estimate-generated>
        <wc-burger-menu>
          <v-list-item @click='toggleArchive'>
            <v-list-item-icon>
              <v-icon :color='$store.state.icons.archive.iconColor'>{{ $store.state.icons.archive.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-if='inquiry.archived'>Un-Archive</v-list-item-title>
              <v-list-item-title v-else>Archive</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click='setupEstimate'>
            <v-list-item-icon>
              <v-icon :color='$store.state.icons.modules.estimates.color'>{{ $store.state.icons.modules.estimates.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Start New Estimate</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </wc-burger-menu>
      </template>
    </wc-page-title>
    <v-container v-if='inquiry && inquiry.archived'>
      <v-alert type='error' border='bottom'>This Inquiry has been archived</v-alert>
    </v-container>
    <router-view v-if='inquiry' :inquiry='inquiry' @update='update'></router-view>
    <inquiry-tracker ref='actionTracker' title='Notes' textTitle='Note' v-if='inquiry' :inquiry='inquiry'></inquiry-tracker>

    <new-estimate-setup
      v-if='inquiry'
      :showDialog='showEstimateSetup'
      :division='inquiry.division_obj'
      :projects='projects'
      :siteReference='{ address: inquiry.site_address, city: inquiry.site_city }'
      :contactReference='{ 
        name: inquiry.name, 
        last_name: inquiry.last_name, 
        cell_phone: inquiry.cell_phone, 
        email: inquiry.email ,
        address: inquiry.site_address,
        city: inquiry.site_city,
        province: inquiry.site_province,
        postal_code: inquiry.site_postal_code,
        country: inquiry.site_country
      }'
      showSiteAddress
      showContact
      showContactReference
      @cancel='showEstimateSetup = false'
      @estimateCreated='recordEstimateCreated'
    ></new-estimate-setup>

  </div>
</template>

<script>
import inquiriesAPI from '../../api/inquiries';
import InquiryTracker from '@/components/trackers/InquiryTracker';
import trackerAPI from '@/api/tracker';
import moment from 'moment';
import irrigationAPI from '@/modules/irrigation/api/irrigations';
import NewEstimateSetup from '@/modules/estimates/components/NewEstimateSetup';
import WCEstimateGenerated from '@/components/chips/WCEstimateGenerated';
import _ from 'lodash';

export default {
  name: 'inquiry-base',
  data: () => ({
    isLoading: true,
    updating: true,
    showEstimateSetup: false,
    inquiry: null,
    inquiryCopy: null,
    projects: [],
  }),
  computed: {
    title () {
      if (this.inquiry) {
        return this.inquiry.name + ' ' + this.inquiry.last_name
      }
      return ''
    },
    subtitle () {
      if (this.inquiry) {
        return this.inquiry.division_obj.division
      }
      return ''
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.inquiry = await inquiriesAPI.getInquiry(this.$route.params.id)
      this.isLoading = false
    },
    async update (obj) {
      this.updating = true
      this.inquiry = await inquiriesAPI.updateInquiry(obj)
      this.updating = false
    },
    async setupEstimate () {
      this.projects = _.orderBy(await irrigationAPI.irrigationSelectList(), 'name')
      this.showEstimateSetup = true
    },
    async toggleArchive () {
      this.updating = true;
      this.inquiry.archived = !this.inquiry.archived;
      this.update(this.inquiry);
      const description = this.inquiry.archived ? 'Archived inquiry' : 'UN-Archived inquiry';
      const tracker = {
          'tracker_data': {
            'description': description,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString(),
          },
          'inquiry': this.inquiry.id
      }
      const res = await trackerAPI.createInquiryTracker(tracker);
      this.$refs.actionTracker.pushItem(res);
    },
    recordEstimateCreated (est) {
      this.inquiry.estimate_generated = true;
      this.update(this.inquiry);
      const tracker = {
          'tracker_data': {
            'description': 'Created estimate number #' + est.number,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString(),
          },
          'inquiry': this.inquiry.id
      }
      trackerAPI.createInquiryTracker(tracker);
    }
  },
  components: {
    'inquiry-tracker': InquiryTracker,
    'new-estimate-setup': NewEstimateSetup,
    'wc-estimate-generated': WCEstimateGenerated
  }
}
</script>
